// extracted by mini-css-extract-plugin
module.exports = {"component":"PopoverNone_component__mEeDs","inner":"PopoverNone_inner__JZ9ki","footer":"PopoverNone_footer__1P-jk"};